// #1712: de grafieken van het Managementdashboard, met ApexCharts (dezelfde
// bibliotheek als de andere dashboards). Kleuren komen uit de themalaag
// (--cc-*), zodat de grafiek de huisstijl van het bedrijf volgt.
//
//   soort "trend"     staven sales en leavers per periode, lijn netto groei
//   soort "verdeling" liggende staven: actieve leden per lidmaatschap
import { Controller } from "stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = { soort: String, data: Object }

  connect() {
    const stijl = getComputedStyle(this.element)
    const kleur = (naam, standaard) => (stijl.getPropertyValue(naam) || "").trim() || standaard
    this.kleuren = {
      primair: kleur("--cc-primary", "#AA0B18"),
      opPrimair: kleur("--cc-on-primary", "#FFFFFF"),
      goed: kleur("--cc-confirm", "#2E7D5B"),
      signaal: kleur("--cc-signal", "#C2410C"),
      inkt: kleur("--cc-ink", "#161311"),
      gedempt: kleur("--cc-muted", "#6E6459"),
      lijn: kleur("--cc-line", "#E6E1DB"),
      font: kleur("--cc-font-interface", "Inter, system-ui, sans-serif")
    }
    const opties = this.soortValue === "verdeling" ? this.verdeling() : this.trend()
    this.grafiek = new ApexCharts(this.element, opties)
    this.grafiek.render()
  }

  disconnect() {
    if (this.grafiek) this.grafiek.destroy()
  }

  basis(hoogte) {
    return {
      height: hoogte,
      fontFamily: this.kleuren.font,
      foreColor: this.kleuren.gedempt,
      toolbar: { show: false },
      zoom: { enabled: false },
      animations: { enabled: false }
    }
  }

  trend() {
    const d = this.dataValue
    return {
      chart: { ...this.basis(300), type: "line", stacked: false },
      series: [
        { name: d.namen.sales, type: "column", data: d.sales },
        { name: d.namen.leavers, type: "column", data: d.leavers },
        { name: d.namen.netto, type: "line", data: d.netto }
      ],
      colors: [this.kleuren.goed, this.kleuren.signaal, this.kleuren.inkt],
      stroke: { width: [0, 0, 2.5], curve: "straight" },
      markers: { size: [0, 0, 4] },
      plotOptions: { bar: { columnWidth: "55%", borderRadius: 3 } },
      xaxis: { categories: d.labels, axisBorder: { color: this.kleuren.lijn }, axisTicks: { show: false } },
      yaxis: { forceNiceScale: true, labels: { formatter: (v) => Math.round(v) } },
      grid: { borderColor: this.kleuren.lijn, strokeDashArray: 4 },
      dataLabels: { enabled: false },
      legend: { position: "top", horizontalAlign: "left" },
      tooltip: { shared: true, intersect: false }
    }
  }

  verdeling() {
    const d = this.dataValue
    return {
      chart: { ...this.basis(Math.max(160, d.labels.length * 38 + 40)), type: "bar" },
      series: [{ name: d.naam, data: d.aantallen }],
      colors: [this.kleuren.primair],
      plotOptions: { bar: { horizontal: true, barHeight: "62%", borderRadius: 3 } },
      xaxis: { categories: d.labels, labels: { formatter: (v) => Math.round(v) } },
      grid: { borderColor: this.kleuren.lijn, strokeDashArray: 4 },
      dataLabels: { enabled: true, style: { colors: [this.kleuren.opPrimair] } },
      legend: { show: false }
    }
  }
}
